module.exports = __webpack_public_path__ + "img/banner_award.ea5302d5.jpg";